export default __webpack_public_path__ + "static/media/Wave.b8e3cae0.svg";